// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2630":"1f941d65fab8a497","2888":"c2ab97d157429dcf","8552":"367c8343b538cb8b"}[chunkId] + ".css";
};